import { CalendarClock, Scale, ShieldCheck, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";
import { JumpLink } from "@/components/aziende/Piani";
import { PROMO_TEXT } from "@/components/aziende/plans";

const POINTS = [
  { id: "tempo", Icon: CalendarClock, title: "Ogni giorno conta.", text: "Un ruolo scoperto rallenta i progetti, sovraccarica il team e rimanda i risultati. Ogni settimana di attesa ha un prezzo, anche se non compare in fattura." },
  { id: "confronto", Icon: Scale, title: "Fai il confronto giusto.", text: "Un'agenzia di selezione chiede una percentuale della RAL per ogni assunzione: nel calcolatore usiamo il 15%. Con Prodigy paghi una quota annuale fissa." },
  { id: "certezza", Icon: ShieldCheck, title: "Nessuna sorpresa.", text: "Nessuna fee sulle assunzioni. Un prezzo fisso, noto in anticipo, che non cresce quando cresce la tua squadra." },
  { id: "promo", Icon: Sparkles, title: "Primi 6 partner gratis.", text: PROMO_TEXT },
];

export const PianiBridge = () => (
  <section className="relative px-6 py-16 lg:py-28" data-testid="piani-bridge-section">
    <Reveal className="max-w-6xl mx-auto">
      <div className="bridge-panel glass rounded-[28px] border p-7 sm:p-12 lg:p-16">
        <Eyebrow className="mb-6">Prima di decidere</Eyebrow>
        <h2 className="max-w-3xl font-extrabold tracking-[-0.04em] leading-[1.04] text-3xl sm:text-5xl lg:text-6xl" data-testid="bridge-title">
          Il costo più alto è quello che non vedi.
        </h2>
        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:gap-12">
          {POINTS.map(({ id, Icon, title, text }) => (
            <div key={id} className="flex gap-4" data-testid={`bridge-point-${id}`}>
              <span className="h-11 w-11 shrink-0 rounded-2xl border border-[#1e2024] flex items-center justify-center">
                <Icon className="h-5 w-5 text-cyan" strokeWidth={1.5} />
              </span>
              <div>
                <h3 className="font-bold text-lg sm:text-xl text-white">{title}</h3>
                <p className="mt-2 text-sm sm:text-base leading-relaxed text-titanium">{text}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-14 border-t border-[#1e2024] pt-10 font-extrabold tracking-[-0.03em] leading-[1.1] text-2xl sm:text-4xl text-white" data-testid="bridge-identity">
          Le aziende migliori scelgono le persone, <span className="text-cyan">non i CV.</span>
        </p>
        <JumpLink to="calcolatore" testId="bridge-calc-jump" className="mt-8">
          Mettilo alla prova con i tuoi numeri.
        </JumpLink>
      </div>
    </Reveal>
  </section>
);
